<!--go-chat-duplication-->
<app-dialog #dialog
            (confirm)="confirmButtonClicked()"
            confirmButtonText="Refresh"
            title="Connection lost">
            Your connection may be unstable.  Please refresh the page and try again.  (disconnect)
</app-dialog>
